import axios from 'axios';
import { starter2Api } from '../constants/Endpoint';
import { adios } from '@adserve/adserve-react-components';
import qs from 'qs';
import moment from 'moment';

export const GetAll = async (entity) => {
    try {
        const result = await adios(() => axios.get(`${starter2Api}/${entity}/?pageSize=1000&pageNumber=1`));
        if (result.data.data) {
            return result.data.data;
        } else {
            return result.data;
        }
    } catch (e) {
        return [];
    }
};
export const CreateObject = async (entity, value) => {
    const result = await adios(() => axios.post(`${starter2Api}/${entity}`, value));
    return result.data;
};

export const GetRegistryValue = async (key) => {
    try {
        let url = `${starter2Api}/registry/${key}`;
        const result = await adios(() => axios.get(url));
        return result?.data;
    } catch (e) {
        return {};
    }
};

export const GetSurveys = async () => {
    try {
        const result = await adios(() => axios.get(`${starter2Api}/surveys/?pageSize=1000`));
        return result.data.data;
    } catch (e) {
        return [];
    }
};

export const GetDemographics = async () => {
    try {
        const result = await adios(() =>
            axios.get(`${starter2Api}/demographics/?pageSize=5000&SortField=name&SortOrder=1`)
        );
        return result.data.data;
    } catch (e) {
        return [];
    }
};

export const GetBaseDemographic = async () => {
    try {
        const result = await adios(() => axios.get(`${starter2Api}/demographic/base`));
        return result?.data;
    } catch (e) {
        return {};
    }
};

export const GetNetworks = async (ledgerId) => {
    try {
        const result = await adios(() => axios.get(`${starter2Api}/Networks/${ledgerId}`));
        console.log('networks', result);
        return result?.data;
    } catch (e) {
        return [];
    }
};

export const GetShowNetworks = async () => {
    try {
        const result = await adios(() => axios.get(`${starter2Api}/Networks?includeChildren=true`));
        return result?.data;
    } catch (e) {
        return [];
    }
};
export const GetActiveStations = async () => {
    try {
        const result = await adios(() => axios.get(`${starter2Api}/stations/selectlist`));
        return result?.data;
    } catch (e) {
        return [];
    }
};
export const GetNetworkHierarchy = async (ledgerId) => {
    alert('why is this called');
};
export const GetDealNetworkHierarchy = async (ledgerId, dealVersionId, isPlanning = true) => {
    try {
        let url = `${starter2Api}/Networks/DealHierarchy`;
        //        if (ledgerId) {
        //            url += `/?ledgerId=${ledgerId}`;
        //        }
        const result = await adios(() =>
            axios.get(url, { params: { ledgerId: ledgerId, dealVersionId: dealVersionId, isPlanning: true } })
        );
        return result?.data;
    } catch (e) {
        return [];
    }
};

export const GetPackage = async (packageId) => {
    try {
        let url = `${starter2Api}/sAndPProperty/${packageId}`;
        const result = await adios(() => axios.get(url));
        return result?.data;
    } catch (e) {
        return {};
    }
};
export const GetAllStations = async () => {
    try {
        const networks = await GetNetworkHierarchy();
        const stationsData = [];
        networks?.forEach((network) => {
            network.children?.forEach((subNet) => {
                subNet.children?.forEach((station) => {
                    if (stationsData.find((x) => x?.id === station.id) === undefined) {
                        // Add when it doesn't exist
                        stationsData.push(station);
                    }
                });
            });
        });
        return stationsData;
    } catch (e) {
        return [];
    }
};

export const GetLedgers = async () => {
    try {
        const result = await adios(() => axios.get(`${starter2Api}/Ledgers/foruser`));
        return result?.data;
    } catch (e) {
        return [];
    }
};

export const GetShows = async (params) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/Shows/Search`, {
            params,
            paramsSerializer: (params) => {
                return qs.stringify(params);
            }
        })
    );

    return result?.data;
};
export const GetPackages = async (params) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/SandPProperties/Search`, {
            params,
            paramsSerializer: (params) => {
                return qs.stringify(params);
            }
        })
    );

    return result?.data;
};

export const GetExternalSource = async (name) => {
    const result = await adios(() => axios.get(`${starter2Api}/ExternalSources/search`, { params: { name }}));
    if (result?.data.data && result?.data.data.length > 0)
        return result.data.data[0];

    return undefined;
};

export const GetShowsWithAvails = async (params) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/Shows/SearchWithAvails`, {
            params,
            paramsSerializer: (params) => {
                return qs.stringify(params);
            }
        })
    );

    return result?.data;
};

export const GetReservationTimes = async (params) => {
    const result = await adios(() =>
        axios.get(`${starter2Api}/ReservationTimes`, {
            params,
            paramsSerializer: (params) => {
                return qs.stringify(params);
            }
        })
    );

    return result?.data;
};

export const GetShow = async (id) => {
    const result = await adios(() => axios.get(`${starter2Api}/show/${id}`));
    return result?.data;
};

export const DeleteShow = async (id) => {
    const result = await adios(() => axios.delete(`${starter2Api}/Show/${id}`));
    return result?.data;
};

export const ToggleShowFavourite = async (id) => {
    await adios(() => axios.post(`${starter2Api}/favourite/show`, { id }));
};

export const GetProperties = async (params) => {
    let result;
    try {
        result = await adios(() => axios.get(`${starter2Api}/properties/saleable/search`, { params }));
    } catch (error) {
        console.log(error);
    }

    return result?.data;
};

export const GetProperty = async (id) => {
    let result;
    try {
        result = await adios(() => axios.get(`${starter2Api}/property/${id}`));
    } catch (error) {
        console.log(error);
    }

    return result?.data;
};

export const CreateProperty = async (data) => {
    try {
        return await adios(() => {
            axios.post(`${starter2Api}/property`, data);
        });
    } catch (error) {
        console.log(error);
    }
};

export const UpdateProperty = async (data) => {
    try {
        return await adios(() => {
            axios.patch(`${starter2Api}/property`, data);
        });
    } catch (error) {
        console.log(error);
    }
};

export const DeleteProperty = async (id) => {
    try {
        return await adios(() => {
            axios.delete(`${starter2Api}/property/${id}`);
        });
    } catch (error) {
        console.log(error);
    }
};

export const ToggleAvailableForSelection = async (id) => {
    await adios(() => {
        axios.patch(`${starter2Api}/property/toggleAvailableForSelection`, {
            id
        });
    });
};

export const CreateCampaignProperty = async (data) => {
    try {
        const result = await adios(() => axios.post(`${starter2Api}/campaignProperty`, data));
        return result?.data;
    } catch (error) {
        console.log(error);
    }
};
export const CreateOrUpdateCampaignPackage = async (data) => {
    try {
        const result = await adios(() => axios.post(`${starter2Api}/campaignPackage`, data));
        return result?.data;
    } catch (error) {
        console.log(error);
    }
};
export const QuoteCampaignPackage = async (id, waitId) => {
    const result = await adios(() =>
        axios.post(`${starter2Api}/campaignPackage/Quote?id=${id}&waitMessageId=${waitId}`)
    );
    return result?.data;
};
export const DeleteCampaignPackage = async (campaignPackageId) => {
    try {
        const result = await adios(() => axios.delete(`${starter2Api}/campaignPackage/${campaignPackageId}`));
        return result?.data;
    } catch (error) {
        console.log(error);
    }
};
export const DeleteCampaignProperty = async (campaignPropertyId) => {
    try {
        const result = await adios(() => axios.delete(`${starter2Api}/campaignProperty/${campaignPropertyId}`));
        return result?.data;
    } catch (error) {
        console.log(error);
    }
};
export const ListCampaignPackages = async (campaignId) => {
    try {
        const result = await adios(() => axios.get(`${starter2Api}/campaignPackages/${campaignId}`));
        return result?.data;
    } catch (error) {
        console.log(error);
    }
};
export const ReserveCampaignProperty = async (id, waitId) => {
    try {
        const data = {
            id: id,
            waitMessageId: waitId
        };
        const result = await adios(() => axios.post(`${starter2Api}/campaignProperty/reserve`, data));

        return result?.data;
    } catch (error) {
        console.log(error);
    }
};

export const GetCampaignProperties = async (campaignId) => {
    let result;
    try {
        result = await adios(() => axios.get(`${starter2Api}/campaign/${campaignId}/campaignProperties`));
    } catch (error) {
        console.log(error);
    }

    return result?.data;
};

export const GetUser = async (userId) => {
    try {
        const result = await adios(() => axios.get(`${starter2Api}/user/${userId}`));
        return result?.data;
    } catch (error) {
        console.log(error);
    }
};

export const GetPropertyStatsByDeal = async (properties = [], dealId, startDate, endDate) => {
    const requestProperties = JSON.parse(JSON.stringify(properties));
    const sDate = moment(startDate)?.toISOString();
    const eDate = moment(endDate)?.toISOString();
    requestProperties?.forEach((rp) => {
        delete rp.linkedStationNames
        rp.linkedStationNames = JSON.stringify(rp.linkedStationNames);
    })
    let result;
    try {
        result = await adios(() => axios.post(`${starter2Api}/sandPProperty/getStatsByDeal`, {
            properties: requestProperties,
            dealId: dealId,
            startDate: sDate,
            endDate: eDate
        }));
    } catch (error) {
        console.log(error);
    }

    return result?.data;
};
